import { Checkbox } from '@material-ui/core';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import { useState } from 'react';
import { ReactComponent as DeleteButtonSvg } from '../../../../images/delete-btn.svg';
import filter from '../../../../images/icon-filter.png';
import { ReactComponent as PlayButtonSvg } from '../../../../images/play-btn.svg';
import { ReactComponent as ShareButtonSvg } from '../../../../images/share-btn.svg';
import Filters from '../Filters';
import ExportPdfButton from '../../../flags/components/ExportPdfButton';
import '../../styles/pdfViewer.css';
import { isKeyIdeaFlag } from '../../../../utils/tagValidatorUtils';

const FlagsRightSideHeader = ({
  handleFilter,
  clickMyFlags,
  clickSharedFlags,
  clickAiFlags,
  selectFlagsBtn,
  handleSelectionFlagsBtn,
  selectedItems,
  handlePlayFlagsActionBtn,
  handleSelectedDelete,
  setFlagsToShowOnRight,
  groupedFlagsByText,
  instance,
  documentUrl,
  podcastUrl,
  handleShareModalInit,
  setClickSharedFlags,
  uniqueSharers,
  setClickAiFlags,
  isLoadingFilters,
  setIsLoadingFilters,
  isPersonalPodcast,
  exportNotes,
  isFromPdfViewerPage
}) => {
  const [show, setShow] = useState(null);
  const [showOptions, setShowOptions] = useState(false);

  const checkboxHeaderClassname = `header-menu ${
    isLoadingFilters ? 'disabled' : ''
  }`;

  const handleShow = (e) => {
    setShow(e.currentTarget);
  };
  const handleClose = () => setShow(false);

  const handlePlayFlagsBtn = (e) => {
    if (selectedItems?.length > 0) {
      handlePlayFlagsActionBtn(e);
    } else {
      return;
    }
  };

  const handleToggleOptions = (e) => {
    setShowOptions((prev) => !prev);
  }

  const handleShareFlagsBtn = (e) => {
    if (selectedItems?.length > 0) {
      handleShareModalInit(e, selectedItems);
    } else {
      return;
    }
  };

  return (
    <>
      {show ? (
        <Filters
          show={show}
          handleClose={handleClose}
          uniqueSharers={uniqueSharers}
          instance={instance}
          setFlagsToShowOnRight={setFlagsToShowOnRight}
          documentUrl={documentUrl}
          podcastUrl={podcastUrl}
          clickMyFlags={clickMyFlags}
          clickSharedFlags={clickSharedFlags}
          clickAiFlags={clickAiFlags}
          setClickSharedFlags={setClickSharedFlags}
          setClickAiFlags={setClickAiFlags}
          isLoadingFilters={isLoadingFilters}
          setIsLoadingFilters={setIsLoadingFilters}
        />
      ) : (
        <></>
      )}

      {isFromPdfViewerPage && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
            paddingTop: '16px'
          }}
        >
          <ExportPdfButton onExport={exportNotes} fromPdf={true} />
        </div>
      )}

      <div style={{ display: 'flex', marginBottom: '5px', marginTop: '20px' }}>
        <div
          style={{
            fontSize: 18,
            fontWeight: 400,
            flexGrow: isFromPdfViewerPage ? 0 : 1,
            letterSpacing: '0.05em'
          }}
        >
          Flags
        </div>
        <div
          className={isFromPdfViewerPage ? 'pdf-viewer-header-filter' : 'header-filter'}
          onClick={(e) => {
            handleShow(e);
          }}
        >
          <div style={{ fontSize: 14, fontWeight: 500, flexGrow: 1 }}>
            Filter
          </div>
          <img width="30" height="18" src={filter} />
        </div>
        {isFromPdfViewerPage && (
          <div
            className='pdf-viewer-header-filter'
            onClick={(e) => {
              handleToggleOptions(e);
            }}
          >
            <div style={{ fontSize: 14, fontWeight: 500, flexGrow: 1 }}>
              {showOptions ? 'Hide' : ''} Options
            </div>
           
          </div>
        )}
      </div>

      {(!isFromPdfViewerPage || showOptions) && (
        <>
      <div className={checkboxHeaderClassname}>
        <div style={{ flex: '1' }}>
          <Checkbox
            className="pdf-filter__checkbox"
            checked={clickMyFlags ? true : false}
            onChange={() => handleFilter('my')}
            icon={<RadioButtonUncheckedIcon fontSize="large" />}
            checkedIcon={<RadioButtonCheckedIcon fontSize="large" />}
            disabled={isLoadingFilters}
          />
        </div>
        <div style={{ flex: '11' }}>Personal</div>
      </div>
      <div className={checkboxHeaderClassname}>
        <div style={{ flex: '1' }}>
          <Checkbox
            className="pdf-filter__checkbox"
            checked={
              clickSharedFlags === 1 || clickSharedFlags === 2 ? true : false
            }
            onChange={() => handleFilter('shared')}
            icon={<RadioButtonUncheckedIcon fontSize="large" />}
            checkedIcon={
              clickSharedFlags === 1 ? (
                <RadioButtonCheckedIcon fontSize="large" />
              ) : (
                <RadioButtonCheckedIcon
                  fontSize="large"
                  style={{ color: '#FBC6E6' }}
                />
              )
            }
            disabled={isLoadingFilters}
          />
        </div>
        <div style={{ flex: '11' }}>Shared</div>
      </div>
      <div className={checkboxHeaderClassname}>
        <div style={{ flex: '1' }}>
          <Checkbox
            className="pdf-filter__checkbox"
            checked={clickAiFlags ? true : false}
            onChange={() => handleFilter('ai')}
            icon={<RadioButtonUncheckedIcon fontSize="large" />}
            checkedIcon={<RadioButtonCheckedIcon fontSize="large" />}
            disabled={isLoadingFilters}
          />
        </div>
        <div style={{ flex: '11' }}>AI identified key sentences</div>
      </div>

      <div className="header-menu-border">
        <div className="selected-flags-actions-wrapper-rs">
          <div
            title="Play selected"
            onClick={(e) => handlePlayFlagsBtn(e)}
            style={{
              cursor: selectedItems?.length > 0 ? 'pointer' : 'not-allowed',
              width: '40px',
              height: '40px',
              marginRight: '10px'
            }}
          >
            <PlayButtonSvg
              stroke={selectedItems?.length > 0 ? 'none' : 'rgb(159,173,188)'}
              fill={selectedItems?.length > 0 ? '#7d7d7f' : 'none'}
              width={40}
              height={40}
            />
          </div>
          {!isPersonalPodcast && (
            <div
              title="Share selected"
              onClick={(e) => handleShareFlagsBtn(e)}
              style={{
                cursor: selectedItems?.length > 0 ? 'pointer' : 'not-allowed',
                width: '24px',
                height: '24px',
                marginRight: '10px'
              }}
            >
              <ShareButtonSvg
                stroke={selectedItems?.length > 0 ? 'none' : 'rgb(159,173,188)'}
                fill={selectedItems?.length > 0 ? '#7d7d7f' : 'none'}
                width={20}
                height={20}
              />
            </div>
          )}
          <div
            title="Delete selected"
            {...(selectedItems?.length > 0 && {
              onClick: (e) => handleSelectedDelete(e, selectedItems)
            })}
            style={{
              cursor: selectedItems?.length > 0 ? 'pointer' : 'not-allowed'
            }}
          >
            <DeleteButtonSvg
              stroke={
                selectedItems?.length > 0 ? '#7d7d7f' : 'rgb(159,173,188)'
              }
              fill="none"
              width={22}
              height={22}
            />
          </div>
        </div>
        <div
          onClick={() => handleSelectionFlagsBtn()}
          id="flags-actions-select-flags"
          style={{
            color: selectFlagsBtn.isActive ? '#7d7d7f' : 'rgb(159,173,188)',
            fontSize: '15px',
            fontWeight: 600,
            cursor: 'pointer',
            paddingRight: '20px'
          }}
        >
          <span
            className="btn-select-flags__title"
            style={{ textDecoration: 'underline #7634a9', fontWeight: 400 }}
          >
            {selectFlagsBtn.isActive ? 'Close' : 'Manage Flags'}
          </span>
        </div>
      </div>
      </>
      )}
    </>
  );
};

export default FlagsRightSideHeader;
